import { render } from "./ProjectsScreen.vue?vue&type=template&id=68a5e29c&scoped=true"
import script from "./ProjectsScreen.vue?vue&type=script&lang=js"
export * from "./ProjectsScreen.vue?vue&type=script&lang=js"

import "./ProjectsScreen.vue?vue&type=style&index=0&id=68a5e29c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a5e29c"]])

export default __exports__